import React from 'react';
import { Container } from 'react-bootstrap';
import { FaInstagram, FaPhoneAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import ContactNavbar from './ContactNavbar';
import NavigationNavbar from './NavigationNavbar';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import PictureGallerySection from './PictureGallerySection';
import CoverageSection from './CoverageSection';
import ContactSection from './ContactSection';
import './App.css';

function App() {
  return (
    <div className="site-frame">
      <ContactNavbar />
      <NavigationNavbar />

      <main className="site-shell">
        <HeroSection />
        <AboutSection />
        <PictureGallerySection />
        <CoverageSection />
        <ContactSection />
      </main>

      <footer className="site-footer">
        <Container className="site-footer__content">
          <div>
            <p className="site-footer__brand">Moonwood Electrical</p>
            <p className="site-footer__text">
              Based in Spixworth, serving Norwich and surrounding areas with
              domestic, commercial, industrial, inspection and solar work.
            </p>
          </div>

          <div className="site-footer__links">
            <a href="tel:+447969087406">
              <FaPhoneAlt aria-hidden="true" />
              <span>07969 087406</span>
            </a>
            <a href="mailto:moonwoodelectrical@gmail.com">
              <MdEmail aria-hidden="true" />
              <span>moonwoodelectrical@gmail.com</span>
            </a>
          </div>

          <div className="site-footer__social">
            <a
              href="https://www.instagram.com/moonwood_electrical/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Moonwood Electrical on Instagram"
            >
              <FaInstagram aria-hidden="true" />
              <span>Instagram</span>
            </a>
          </div>
        </Container>
      </footer>

      <div className="mobile-cta-bar">
        <a className="mobile-cta-bar__button" href="tel:+447969087406">
          Call Now
        </a>
        <a
          className="mobile-cta-bar__button mobile-cta-bar__button--secondary"
          href="#contact"
        >
          Request Quote
        </a>
      </div>
    </div>
  );
}

export default App;
